import { fontFamilies as globalFontFamilies } from "../global/fonts.js";
export const fontFamilies = {
  ...globalFontFamilies,
  fontFamilyBase: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, "Apple Color Emoji", "Segoe UI Emoji", sans-serif'
};